import React, { createContext, useContext, useEffect, useRef } from 'react';
import { LoadingBarManager, setActiveLoadingBarManager } from './LoadingBarManager';

const LoadingBarContext = createContext<LoadingBarManager | null>(null);

export function useLoadingBarManager(): LoadingBarManager | null {
    return useContext(LoadingBarContext);
}

export function LoadingBarProvider({ children }: { children: React.ReactNode }) {
    const managerRef = useRef<LoadingBarManager>(new LoadingBarManager());

    useEffect(() => {
        const manager = managerRef.current;
        setActiveLoadingBarManager(manager);

        return () => {
            manager.reset();
            setActiveLoadingBarManager(null);
        };
    }, []);

    return <LoadingBarContext.Provider value={managerRef.current}>{children}</LoadingBarContext.Provider>;
}
